module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"calendar":"Event occurrence calendar","close":"Close calendar","today":"Today","lang":"en-EN","pointOfSale":"Filter by point of sale"},"es":{"calendar":"Calendario de ocurrencias de eventos","close":"Cerrar calendario","today":"Hoy","lang":"es-ES","pointOfSale":"Filtrar por punto de venta"}}')
  delete Component.options._Ctor
}
